import React from "react";
import "./Banner.css";

function Banner() {
  return (
    <div>
      <div className="Banner">
        <img
          className="Banner"
          src="/images/banner.jpg"
          alt="Plane in sky with clouds"
        />
      </div>

      <div className="Banner2">
        <img
          className="Banner2"
          src="images/main-banner.jpeg"
          alt="Plane in sky with clouds"
        />
      </div>
    </div>
  );
}

export default Banner;
